import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'pcm-data-form-field-date',
	templateUrl: './data-form-field-date.component.html',
	styleUrls: ['./data-form-field-date.component.scss'],
	providers: [{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: DataFormFieldDateComponent
	}]
})

// is necessary to implement ControlValueAccessor because the ibm-date-picker component emits "touched" event when interacting
// with the date picker pop-up, which can cause it to close unexpectedly
export class DataFormFieldDateComponent implements ControlValueAccessor {
	@Input() propName: string;
	@Input() name: string;
	@Input() formGroup: UntypedFormGroup;
	@Input() helpMessage: string;
	@Input() invalid = false;
	@Input() invalidText: string;
	@Input() required = false;
	@Input() dateOptions;

	value;
	disabled = false;
	onChange = (newValue) => {};
	onTouched = () => {};

	writeValue(value: any) {
		this.value = [value];
	}
	registerOnChange(onChange: any) {
		this.onChange = onChange;
	}
	registerOnTouched(onTouched: any) {
		this.onTouched = onTouched;
	}
	setDisabledState?(isDisabled: boolean) {
		this.disabled = isDisabled;
	}

	/**
	 * This is a hacky way of forcing the date component calendar to start on Saturday. Carbon Angular's datepicker
	 * wraps Flatpickr, which allows setting this on the locale config. However, Carbon's Angular component overrides this
	 * locale setting, so the only method of editing it is to create a Flatpickr plugin and edit the config on the
	 * Flatpickr internal instance object. Hopefully the Carbon Angular component will allow setting a custom locale
	 * setting in the future, and this hacky method can be removed.
	 */
	datePickerPluginForceStartSaturday(fp) {
		return {
			// event hook
			onParseConfig() {
				fp.config.locale.firstDayOfWeek = 6; // zero-based day of week, 6=saturday
			}
		};
	}

	handleValueChange(newValue) {
		// update this component's value to be in sync with this component as well as the form model
		this.value = newValue;
		// calendar returns array, return only first date
		this.onChange(newValue[0]);

		// mark 'touched' only when a value changes.
		// This is to avoid the issue where clicking the field and then clicking the datepicker pop-up would
		// mark 'touched' and trigger the field to be marked invalid, which would cause the datepicker pop-up to close.
		this.onTouched();
	}
}
